import LogRocket from 'logrocket'
import setupLogRocketReact from 'logrocket-react'

export const init = () => {
  setupLogRocketReact(LogRocket)
}
